<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.PACKAGES.WIZARD_OPEN"
    :handler="showWizard"
  />

  <DialogComponent
    ref="dialog"
    type="fullscreen"
    noInnerPadding
    hideCloseButton
  >
    <PackageDeliveryWizardContent
      v-if="isOpen"
      :draftData="currentDraft"
      @close="hideWizard"
    />
  </DialogComponent>
</template>

<script setup>
import { ref } from 'vue';
import { getCurrentInstance } from 'vue';
import PackageDeliveryWizardContent from './PackageDeliveryWizardContent.vue';

const { proxy } = getCurrentInstance();
const dialog = ref(null);
const currentDraft = ref(null);
const isOpen = ref(false);

const showWizard = (payload) => {
  currentDraft.value = payload?.draft || null;
  isOpen.value = true;
  dialog.value?.show();
};

const hideWizard = () => {
  isOpen.value = false;
  currentDraft.value = null;
  dialog.value?.hide();
};

</script>
